/* 2026-09-26 Andrew: review counter must not send shoppers to judge.me. Unwrap external review links into plain text. */
(function () {
  function fix() {
    document.querySelectorAll('.jdgm-all-reviews-text a[href*="judge.me"], .jdgm-all-reviews-text a[target="_blank"]').forEach(function (a) {
      var s = document.createElement('span');
      s.className = a.className; s.innerHTML = a.innerHTML;
      a.replaceWith(s);
    });
    document.querySelectorAll('.jdgm-all-reviews-text > a[href^="javascript"]').forEach(function (a) {
      a.removeAttribute('href'); a.style.cursor = 'default';
    });
  }
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
  fix();
})();
